import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { UserContext } from 'context/userContext';
//api
import { listLanguages } from 'api/libros';
//custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
//components
import Select from 'components/userzone/CustomSelectSimple';
import Button from 'components/userzone/buttons/ButtonCustom';
import SearchBarWithData from 'components/navbar/SearchBarWithData';

const ListItemsFilter = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const [languages, setLanguages] = useState([]);
  const { handleFilter, cleanSearch, filters, nameList, id } = props;
  const { searchData, setSearchData } = useContext(UserContext);
  const { assignedLibrary } = useAssignedLibrary();
  const { t } = useTranslation(['list', 'libraries']);
  const options = [
    { value: null, label: t('select') },
    { value: 'title', label: `${t('title')} (${t('sort')} A-Z)` },
    { value: '-title', label: `${t('title')} (${t('sort')} Z-A)` },
    { value: 'price', label: `${t('price')} (${t('sortascendant')})` },
    { value: '-price', label: `${t('price')} (${t('sortdescendant')})` },
    { value: '-date', label: `${t('datepublication')} (${t('sortdescendant')})` },
  ];
  const productTypes = [
    { value: 'ebook', type: t('digitalbook') },
    { value: 'book', type: t('paperbook') },
  ];

  const handleCleanSearch = () => {
    cleanSearch();
    setSearchData({ value: '', searchType: '' });
    if (params.type === 'search') navigate(`/${assignedLibrary}/lista/search`);
  };

  const getLanguages = async () => {
    let { data } = await listLanguages({ is_ebook: true });
    if (data) {
      data = data.map((val, i) => {
        return { id: val.id, value: val['nombre'] };
      });
      setLanguages(data);
    }
  };

  useEffect(() => {
    getLanguages();
  }, []);

  return (
    <div className="filterCol">
      <Container fluid>
        <Row className="px-0 mx-0">
          <Col lg={12} className="px-0 mb-5">
            <SearchBarWithData searchData={searchData} />
          </Col>
          <Col lg={12}>
            <p className="filterTitle">{t('sortby')}</p>
          </Col>
          <Col lg={12} className="px-0 d-flex">
            <Select
              onChange={(event) => {
                handleFilter('selectFilter', event.value);
              }}
              options={options}
              placeholder={t('select')}
              value={options.find((option) => option.value === filters.selectFilter)}
            />
          </Col>
        </Row>
        {location.pathname !== '/lista/ebooks' && (
          <Row className="px-0 mx-0">
            <Col className="px-0 mx-0">
              <p className="filterTitle secondary-color mt-3">{t('producttype')}</p>
              {productTypes.map((el, index) => (
                <p
                  onClick={() => handleFilter('typebook', el.value)}
                  className="ml-2"
                  style={{ color: filters.typebook === el.value ? '#f2a20d' : null }}
                  key={`productTypes#${index}}`}
                >
                  {el.type}
                </p>
              ))}
            </Col>
          </Row>
        )}
        <Row className="px-0 mx-0">
          <Col className="px-0 mx-0">
            <p className="filterTitle secondary-color mt-3">{t('language')}</p>
            {languages.map((el, index) => (
              <p className="ml-2" style={{ color: filters.languageFilter === el.id ? '#f2a20d' : null }} key={`lenguajes#${index}}`} onClick={() => handleFilter('languageFilter', (el.id))}>
                {el.value}
              </p>
            ))}
          </Col>
        </Row>
        <Button variant="primary" extraClass="my-3 w-100" onClick={handleCleanSearch}>
          {t('clearsearch', { ns: 'libraries' })}
        </Button>
      </Container>
    </div>
  );
};

ListItemsFilter.propTypes = {
  handleFilter: PropTypes.func,
  cleanSearch: PropTypes.func,
  filters: PropTypes.object
};

export default ListItemsFilter;
